export const isReactSnap =
  window.location.port === "45678" || navigator.userAgent === "ReactSnap";
